import { createPortal } from 'react-dom';
import { useV3Shell } from './V3ShellContext';

// Inside UI V3 a window is drawn on the page body, not inside the side bar that opened it. Inside the bar it is stacked and sized by the bar: the blurred glass behind it
// also covers the bar's own tabs, and it sits off-centre. On the body every window behaves the same way. Outside UI V3 nothing changes: the window is drawn exactly where it
// always was. Wrap the windows a tab opens (the tab itself stays in the bar):  <InBody><SomeModal ... /></InBody>
const InBody = ({ children }) => {
  const shell = useV3Shell();
  return shell ? createPortal(children, document.body) : children;
};

export default InBody;
